import React from 'react';
import { Typography } from '@mui/material';

import { formatGroupRevenueMomPercent } from '../../constants/group-revenue-compare-label';

export interface GroupRevenueKpiMomSubtitleProps {
    /** 接口返回的环比百分比 */
    percentRaw: string | null | undefined;
    /** 已翻译的环比前缀（如「较上周」）；空则不渲染 */
    comparePrefix?: string;
    /** 上涨色 */
    successColor: string;
    /** 下跌色 */
    errorColor: string;
}

/**
 * KPI 卡片第三行：环比前缀 + 百分比，同色同字号；无前缀或无百分比时不渲染
 */
export function GroupRevenueKpiMomSubtitle({
    percentRaw,
    comparePrefix,
    successColor,
    errorColor,
}: GroupRevenueKpiMomSubtitleProps) {
    const percent = formatGroupRevenueMomPercent(percentRaw);
    const prefix = String(comparePrefix ?? '').trim();
    if (!percent || !prefix) return null;

    return (
        <Typography
            variant="h6"
            sx={{
                color: percent.startsWith('-') ? errorColor : successColor,
                fontWeight: 'bold',
                textAlign: 'center',
            }}
        >
            {prefix} {percent}
        </Typography>
    );
}
